"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RewardStatus = void 0;
var RewardStatus;
(function (RewardStatus) {
    RewardStatus["DRAFT"] = "draft";
    RewardStatus["SENT"] = "sent";
    RewardStatus["PENDING"] = "pending";
    RewardStatus["AWAITING_VALIDATION"] = "awaiting_validation";
    RewardStatus["DELIVERED"] = "delivered";
    RewardStatus["FAILED"] = "failed";
})(RewardStatus || (exports.RewardStatus = RewardStatus = {}));
